<!-- P6:1600-1603 head row; deviations (single score, no Experience tile) are on ra-cx-role-card -->
<div class="cx-headrow">
  <div>
    <h1 class="cx-h1">{{ ParseOnly ? 'Your career paths' : 'Your career paths are ready' }}</h1>
    @if (!ParseOnly) {
    <p class="cx-sub">These are careers your CV points toward, ranked by how closely your record fits each one. They are not job postings. Open one to see what it asks for and how you compare.</p>
    }
  </div>
  @if (ShowExploreAll) {
  <button class="cx-btn pri" type="button" (click)="ExploreAll.emit()">
    Explore all career paths
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
  </button>
  }
</div>

<!-- P6:1604 -->
@if (ShowRoleCards) {
  <div class="cx-top">
    @for (role of TopRoles; track role.roleRef) {
      <ra-cx-role-card [Match]="role" [Profile]="ProfileOf(role.roleRef)" />
    }
  </div>
} @else if (ParseOnlyPanel; as panel) {
  <!-- Parse-only: calm, never an error. The panel has no P6 equivalent (spec line 201). -->
  <agu-state-panel [Icon]="panel.Icon" [Title]="panel.Title" [Body]="panel.Body" [PrimaryLabel]="panel.ReviewLabel" (Primary)="OpenReview()" />
}

<div class="cx-lower">
  <!-- Sharpen your results, P6:1620-1629 -->
  <div class="cx-card cx-sharp">
    <div class="cx-sharp-h">
      <div>
        <h2>Sharpen your results</h2>
        <p><b>{{ Counts.confirmed }} of {{ Counts.total }}</b> tags confirmed. Each one sharpens your scores.</p>
      </div>
      <button class="cx-btn sec" type="button" (click)="OpenReview()">
        Review with your CV
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </button>
    </div>

    <!-- tabs with mini rings, P6:375-380, 1608 -->
    <nav class="cx-tabs" aria-label="Tag categories">
      @for (t of TabRings; track t.Category) {
        <button class="cx-tab" [class.on]="t.Category === Category" type="button" [attr.aria-current]="t.Category === Category ? 'true' : null" (click)="SelectCategory(t.Category)">
          <ra-cx-ring [Percent]="t.Percent" [Size]="18" [Complete]="t.Complete" />{{ LabelOf(t.Category) }}
        </button>
      }
    </nav>

    <div class="cx-sharp-b">
      <!-- To review, P6:1622-1624 -->
      <div class="cx-box rev">
        <div class="cx-boxh">
          <span class="cx-dot p" aria-hidden="true"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg></span>
          <h3>To review</h3>
          <span class="n">{{ CategoryView.Pending.length }}</span>
        </div>
        @if (CategoryView.Pending.length > 0) {
          <p class="hint">Tap a tag if it’s true of you, or the × if it isn’t.</p>
          <div class="cx-chips">
            @for (c of CategoryView.PendingShown; track c.providerTagID) {
              <span class="cx-tag rev">
                <button class="add" type="button" [attr.aria-label]="'Confirm ' + c.name" (click)="AcceptCard(c)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>{{ c.name }}
                </button>
                <button class="x" type="button" [attr.aria-label]="'Not me: ' + c.name" (click)="DeclineCard(c)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
                </button>
              </span>
            }
            @if (CategoryView.PendingMore > 0) {
              <button class="cx-link" type="button" (click)="ShowMore('p')">+{{ CategoryView.PendingMore }} more</button>
            }
          </div>
        } @else {
          <p class="cx-empty">All reviewed. Your scores use everything in this tab.</p>
        }
      </div>

      <!-- Confirmed, P6:1625-1629 -->
      <div class="cx-box" [class.editing]="Editing">
        <div class="cx-boxh">
          <span class="cx-dot c" aria-hidden="true"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>
          <h3>Confirmed</h3>
          <span class="n">{{ CategoryView.Confirmed.length }}</span>
          <span class="sp"></span>
          @if (HasRemovable) {
            <button class="cx-link" type="button" [attr.aria-pressed]="Editing" (click)="ToggleEditing()">{{ Editing ? 'Done' : 'Edit' }}</button>
          }
        </div>
        <!-- Deviation (P6:405-409, 1629): P6 takes any text; here the name must be in the vocabulary the matches use, because the server asserts a tag id. -->
        @if (ShowPicker) {
        <form class="cx-addown" (submit)="$event.preventDefault(); Add()">
          <input #own type="text" list="cxOwnList" autocomplete="off" [value]="pickerValue" [placeholder]="'Add your own ' + Noun" [attr.aria-label]="'Add your own ' + Noun"
              [attr.aria-invalid]="pickerError !== null" [attr.aria-describedby]="pickerError !== null ? 'cxPickerErr' : null" (input)="OnPickerInput(own.value)" />
          <button class="cx-btn sec" type="submit">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>Add
          </button>
        </form>
        @if (pickerError) { <p class="cx-pickerr" id="cxPickerErr" role="alert">{{ pickerError }}</p> }
        <p class="cx-addown-n">Not on your CV? Add it and your scores update.</p>
        }
        @if (CategoryView.Confirmed.length > 0) {
          <div class="cx-chips">
            @for (c of CategoryView.ConfirmedShown; track c.providerTagID) {
              <span class="cx-tag ok" [class.own]="c.Own">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>{{ c.Name }}@if (c.Own) {<span class="by">· Added by you</span><button class="x" type="button" [attr.aria-label]="'Remove ' + c.Name" (click)="RemoveOwn(c.providerTagID)">×</button>} @else if (c.Approved) {<button class="x" type="button" [attr.aria-label]="'Remove ' + c.Name + ' from confirmed'" (click)="UndoChip(c)">×</button>}
              </span>
            }
            @if (CategoryView.ConfirmedMore > 0) {
              <button class="cx-link" type="button" (click)="ShowMore('c')">+{{ CategoryView.ConfirmedMore }} more</button>
            }
          </div>
        } @else {
          <p class="cx-empty">Nothing confirmed here yet.</p>
        }
        <datalist id="cxOwnList">
          @for (n of PickerNames; track n) { <option [value]="n"></option> }
        </datalist>
      </div>
    </div>
  </div>

  <!-- side: Your CV and More roles, P6:1630 -->
  <div class="cx-side">
    <div class="cx-card cx-cv">
      <h2>Your CV</h2>
      @if (ShowThumbnail) {
        <!-- P6:414-416. The viewer sizes its canvas to this box's width, so the prototype's `--s = width / 760` scale is not needed. -->
        <button class="cx-thumb" type="button" aria-label="Open your CV in review" (click)="OpenReview()">
          <ra-cx-pdf-viewer Mode="thumbnail" [Url]="DownloadUrl" [FileName]="Cv?.fileName ?? ''" />
        </button>
      } @else {
        <div class="cx-thumb cx-thumb--none" aria-hidden="true"></div>
      }
      <div class="cx-fn" [attr.title]="Cv?.fileName">{{ Cv?.fileName }}</div>
      <div class="cx-cvact">
        <button class="rp" type="button" (click)="Replace.emit()">Replace</button>
        <button class="dl" type="button" (click)="Delete.emit()">Delete</button>
      </div>
    </div>

    @if (ShowMoreRoles) {
      <h3 class="cx-moreh">More roles to explore</h3>
      @for (row of MoreRolesList; track row.Match.roleRef) {
        <button class="cx-card cx-mrow" type="button" (click)="OpenRole(row.Match.roleRef)">
          <span class="t"><b>{{ row.Match.title }}</b><span>{{ row.Sub }}</span></span>
          <ra-cx-ring [Percent]="row.Percent" [Size]="50" />
          <span class="cx-sr">{{ row.PercentLabel }} match</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </button>
      }
    }
  </div>
</div>
